import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap';
import 'react-notifications/lib/notifications.css';
import MetaPixel from './common_comp/MetaPixel';
import { HelmetProvider } from "react-helmet-async";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthRoute from './pages/auth';
import Homepage from './pages/public/Homepage/Homepage';
import About from './pages/public/About/About';
import Dashboard from './pages/public/ArtcileDashboard/Dashboard';
import EditorialBoard from './pages/public/Editorial/Editorial';
import AuthorDash from './pages/public/AuthorDashboard/AuthorDash';
import Reviewdash from './pages/public/ReviewDashboard/Reviewdash';
import Journalinfo from './pages/public/JournalInfo/Journalinfo';
import Submitarticle from './pages/public/SubmitArticle/Submitarticle';
import Archives from './pages/public/Archives/Archive';
import Volume from './pages/public/Archives/Volume';
import ArticleDetails from './pages/clientdashboard/ArticleDetails';
import ArticleTable from './pages/clientdashboard/ArticleTable';
import ArticleSubmission from './pages/clientdashboard/ArticleSubmission';
import ProtectedRoute from './context/AuthContext';
import SearchText from './pages/public/Archives/SearchArticle';
import CurrentIssue from './pages/public/CurrentIssue/CurrentIssue';
import ArticlePage from './pages/public/CurrentIssue/articleId/Articlepage';
import Privacy from './pages/public/FooterPages/Privacy/Privacy';
import Terms from './pages/public/FooterPages/TermsCondition/TermsCondition';
import Copyright from './pages/public/FooterPages/Copyright/Copyright';
import NotFound from './common_comp/NotFound/NotFound';
import EditorialDash from './pages/public/EditorialDash/EditorialDash';
import DynamicRoute from './pages/public/Archives/DynamicRoute';
import DynamicTitle from './pages/public/Dynamictitle';
import ContactForm from './pages/public/Contactus/Contactus';
import WhatsAppWidget from './Whatsappwidget';
import EthicsPolicy from './pages/public/About/EthicsPolicy';
import OpenPolicy from './pages/public/About/OpenPolicy';


function App() {
  return (
    <>
    <MetaPixel />
    <WhatsAppWidget/>
      <NotificationContainer />

      <HelmetProvider>

      <Router>
      <DynamicTitle />

        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/ethics-policy" element={<EthicsPolicy />} />
          <Route path="/open-access-policy" element={<OpenPolicy />} />
          <Route path="/contact-us" element={<ContactForm />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms-condition" element={<Terms />} />
          <Route path="/copyright" element={<Copyright />} />
          <Route path="/journal-information" element={<Journalinfo />} />
          <Route path="/not-found" element={<NotFound />} />

          <Route path="/submit-article" element={<Submitarticle />} />
          <Route path="/issue-archive" element={<Archives />} />
          <Route path="/issue-archive/:volume" element={<Volume />} />
          <Route path="/search/:q" element={<SearchText />} />
          <Route path="/:article" element={<DynamicRoute />} />


          {/* <Route path="/:issues" element={<Issue />} />
          <Route path="/:article" element={<Articleid />} /> */}
          <Route path="/current-issue" element={<CurrentIssue />} />
          <Route path="/article-details/:article" element={<ArticlePage />} />
          <Route path="/information/article-processing-charges/*" element={<Dashboard />} />
          <Route path="/information/editorial-criteria-and-processes/*" element={<EditorialDash />} />
          <Route path="/information/for-authors-2/*" element={<AuthorDash />} />
          <Route path="/for-reviewers/*" element={<Reviewdash />} />
          <Route path="/editorial-board-journal-of-applied-bioanalysis" element={<EditorialBoard />} />
          <Route path="/auth/*" element={<AuthRoute />} />

          <Route  element={<ProtectedRoute />} >
            <Route path="/author/articles" element={<ArticleTable />} />
            <Route path="/author/articles/:id" element={<ArticleDetails />} />
            <Route path="/author/article-submission" element={<ArticleSubmission />} />
          </Route>
        </Routes>
      </Router>
      </HelmetProvider>
    </>

  );
}

export default App;


// import React, { useEffect } from 'react';
// import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap';
// import 'react-notifications/lib/notifications.css';
// import MetaPixel from './common_comp/MetaPixel';
// import { HelmetProvider } from "react-helmet-async";
// import { NotificationContainer } from 'react-notifications';
// import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
// import AuthRoute from './pages/auth';
// import Homepage from './pages/public/Homepage/Homepage';
// import About from './pages/public/About/About';
// import Dashboard from './pages/public/ArtcileDashboard/Dashboard';
// import EditorialBoard from './pages/public/Editorial/Editorial';
// import AuthorDash from './pages/public/AuthorDashboard/AuthorDash';
// import Reviewdash from './pages/public/ReviewDashboard/Reviewdash';
// import Journalinfo from './pages/public/JournalInfo/Journalinfo';
// import Submitarticle from './pages/public/SubmitArticle/Submitarticle';
// import Archives from './pages/public/Archives/Archive';
// import Volume from './pages/public/Archives/Volume';
// import ArticleDetails from './pages/clientdashboard/ArticleDetails';
// import ArticleTable from './pages/clientdashboard/ArticleTable';
// import ArticleSubmission from './pages/clientdashboard/ArticleSubmission';
// import ProtectedRoute from './context/AuthContext';
// import SearchText from './pages/public/Archives/SearchArticle';
// import CurrentIssue from './pages/public/CurrentIssue/CurrentIssue';
// import ArticlePage from './pages/public/CurrentIssue/articleId/Articlepage';
// import Privacy from './pages/public/FooterPages/Privacy/Privacy';
// import Terms from './pages/public/FooterPages/TermsCondition/TermsCondition';
// import Copyright from './pages/public/FooterPages/Copyright/Copyright';
// import NotFound from './common_comp/NotFound/NotFound';
// import EditorialDash from './pages/public/EditorialDash/EditorialDash';
// import DynamicRoute from './pages/public/Archives/DynamicRoute';
// import DynamicTitle from './pages/public/Dynamictitle';
// import ContactForm from './pages/public/Contactus/Contactus';
// import WhatsAppWidget from './Whatsappwidget';
// import EthicsPolicy from './pages/public/About/EthicsPolicy';
// import OpenPolicy from './pages/public/About/OpenPolicy';

// // Component to handle trailing slash redirects
// function TrailingSlashHandler() {
//   const location = useLocation();
//   const navigate = useNavigate();

//   useEffect(() => {
//     // If URL has trailing slash (except root), remove it
//     if (location.pathname !== '/' && location.pathname.endsWith('/')) {
//       const newPath = location.pathname.slice(0, -1) + location.search + location.hash;
//       navigate(newPath, { replace: true });
//     }
//   }, [location, navigate]);

//   return null;
// }

// function App() {
//   return (
//     <>
//       <MetaPixel />
//       <WhatsAppWidget />
//       <NotificationContainer />

//       <HelmetProvider>
//         <Router>
//           {/* Add trailing slash handler */}
//           <TrailingSlashHandler />
//           <DynamicTitle />

//           <Routes>
//             <Route path="/" element={<Homepage />} />
//             <Route path="/about" element={<About />} />
//             <Route path="/ethics-policy" element={<EthicsPolicy />} />
//             <Route path="/open-access-policy" element={<OpenPolicy />} />
//             <Route path="/contact-us" element={<ContactForm />} />
//             <Route path="/privacy" element={<Privacy />} />
//             <Route path="/terms-condition" element={<Terms />} />
//             <Route path="/copyright" element={<Copyright />} />
//             <Route path="/journal-information" element={<Journalinfo />} />
//             <Route path="/not-found" element={<NotFound />} />
//             <Route path="/submit-article" element={<Submitarticle />} />
//             <Route path="/issue-archive" element={<Archives />} />
//             <Route path="/issue-archive/:volume" element={<Volume />} />
//             <Route path="/search/:q" element={<SearchText />} />
//             <Route path="/:article" element={<DynamicRoute />} />
//             <Route path="/current-issue" element={<CurrentIssue />} />
//             <Route path="/article-details/:article" element={<ArticlePage />} />
//             <Route path="/information/article-processing-charges/*" element={<Dashboard />} />
//             <Route path="/information/editorial-criteria-and-processes/*" element={<EditorialDash />} />
//             <Route path="/information/for-authors-2/*" element={<AuthorDash />} />
//             <Route path="/for-reviewers/*" element={<Reviewdash />} />
//             <Route path="/editorial-board-journal-of-applied-bioanalysis" element={<EditorialBoard />} />
//             <Route path="/auth/*" element={<AuthRoute />} />

//             <Route element={<ProtectedRoute />}>
//               <Route path="/author/articles" element={<ArticleTable />} />
//               <Route path="/author/articles/:id" element={<ArticleDetails />} />
//               <Route path="/author/article-submission" element={<ArticleSubmission />} />
//             </Route>
//           </Routes>
//         </Router>
//       </HelmetProvider>
//     </>
//   );
// }

// export default App;